import { render } from "./InvertersRead.vue?vue&type=template&id=9a6c43c6"
import script from "./InvertersRead.vue?vue&type=script&lang=js"
export * from "./InvertersRead.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__